import { render, staticRenderFns } from "./EmailNotification.vue?vue&type=template&id=f3ba7162&scoped=true"
import script from "./EmailNotification.vue?vue&type=script&lang=js"
export * from "./EmailNotification.vue?vue&type=script&lang=js"
import style0 from "./EmailNotification.vue?vue&type=style&index=0&id=f3ba7162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ba7162",
  null
  
)

export default component.exports